import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class LazadaOrderProvider extends HttpRequest {
  getOrders (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/orders', query)
  }

  syncWaitingOrder (body) {
    this.setHeader(getAuthToken())
    return this.post('/lazada/orders/sync-paid', body)
  }

  syncCancelOrder (body) {
    this.setHeader(getAuthToken())
    return this.post('/lazada/orders/sync-cancel', body)
  }

  syncReturnOrder (body) {
    this.setHeader(getAuthToken())
    return this.post('/lazada/orders/sync-return', body)
  }

  shipPackage (orderId) {
    this.setHeader(getAuthToken())
    return this.post(`/lazada/orders/${orderId}/ship`)
  }

  getDocument (payload) {
    this.setHeader(getAuthToken())
    return this.post('/lazada/orders/get-document', payload)
  }

  getLazadaOrderError (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/order-error-logs', query)
  }

  reproduce (body) {
    this.setHeader(getAuthToken())
    return this.post('/lazada/order-error-logs/reproduce', body)
  }

  getReturnOrders (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/return-orders', query)
  }
}
